module.exports = __webpack_public_path__ + "img/money-check-dollar-pen.84c5a9a2.svg";